import { PropsWithChildren } from "react";
import { BrowserRouter } from "react-router-dom";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/firebase/auth";
import { Toaster } from "@/components/ui/toaster";
import { CookieBanner } from "@/components/legal/CookieBanner";
import { TransitionProvider } from "./TransitionProvider";

export default function AppProviders({ children }: PropsWithChildren) {
  return (
    <BrowserRouter>
      <AuthProvider>
        <TooltipProvider delayDuration={200} skipDelayDuration={0}>
          <TransitionProvider>
            {children}
            <Toaster />
            {/* La ruta de render (/render/*) la fotografía Chrome headless para
                el librito del mod: el banner de cookies es `fixed` y salía
                pintado encima de las carillas. */}
            {!window.location.pathname.startsWith('/render/') && <CookieBanner />}
          </TransitionProvider>
        </TooltipProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
